import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FormSelect from './form-select'
import { NavLink, useHistory } from 'react-router-dom'
import { useEffect } from 'react'
import {
  useGetUserCompanies,
  useSwitchCurrentCompany,
} from '../redux/company/hook'
import LoadingBar from './loader-bar'
import LogoSVG from '../assets/img/logo-white.svg'
import HomeSVG from '../assets/svg/sidebar/home-white.svg'
import CalendarSVG from '../assets/svg/sidebar/calendar-sidebar.svg'
import EmployeeSVG from '../assets/svg/sidebar/employees-white.svg'
import LogoutSVG from '../assets/svg/sidebar/logout-white.svg'
import ChatSVG from '../assets/svg/sidebar/chat.svg'
import Button from './button'
import GoogleImage from '../assets/img/google-play-badge.png'
import AppleImage from '../assets/svg/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'
import AddCompanyModal from './modal/add-company/add-company'
import { setDashboardCards } from '../redux/dashboard-card/dashboard-card-slice'
import OnboardingSVG from '../assets/svg/employee-awaiting-approval.svg'

const Sidebar = ({ switchLoading }) => {
  const { user } = useSelector((state) => state.userSlice)
  const { company } = useSelector((state) => state.companySlice)
  const dispatch = useDispatch()
  const [showAddCompany, setShowAddCompany] = useState(false)
  const addCompany = () => {
    history.push('/onboarding/about-company')
  }

  const [sidebarItems, setSidebarItems] = useState([
    {
      name: 'Home',
      icon: HomeSVG,
      route: '/dashboard',
      active: true,
    },
    {
      name: 'My Profile',
      icon: EmployeeSVG,
      route: '/profile',
    },

    {
      name: 'Logout',
      icon: LogoutSVG,
      route: '/logout',
    },
  ])
  let isAdmin =
    user?.company?.employee?.permission_employee_read === 1 ||
    user?.company?.employee?.permission_employee_write === 1 ||
    user?.company?.employee?.permission_salary_read === 1 ||
    user?.company?.employee?.permission_salary_write === 1

  useEffect(() => {
    if (!user?.company_id) return

    if (user?.company?.hr_subscription === 1) {
      const items = [
        {
          name: 'Home',
          icon: HomeSVG,
          route: '/dashboard',
          active: true,
        },

        // {
        //   name: 'Ro-chat',
        //   icon: ChatSVG,
        //   route: '/ro-chat',
        // },
        {
          name: 'My Calendar',
          icon: CalendarSVG,
          route: '/calendar',
        },
        {
          name: 'My Profile',
          icon: EmployeeSVG,
          route: '/profile',
        },
        ...(isAdmin
          ? [
              {
                name: 'Admin Management',
                icon: ChatSVG,
                route: '/admin-management',
              },
            ]
          : []),
        {
          name: 'Logout',
          icon: LogoutSVG,
          route: '/logout',
        },
      ]

      setSidebarItems(items)
    }
  }, [user])

  const [companyOptions, setCompanyOptions] = useState([])
  const { mutateAsync: switchCurrentCompany } = useSwitchCurrentCompany()
  const { data: companies } = useGetUserCompanies()

  const history = useHistory()

  useEffect(() => {
    if (companies) {
      let computeCompanyOptions = []
      computeCompanyOptions.push({
        label: 'My Dashboard',
        value: '-1',
      })
      companies.forEach((company) => {
        computeCompanyOptions.push({
          label: company?.company_name,
          value: company?.company_id,
        })
      })

      setCompanyOptions(computeCompanyOptions)
    }
  }, [companies])

  const [loggedInCompany, setLoggedInCompany] = useState(user?.company_id)

  useEffect(() => {
    if (loggedInCompany) {
      if (loggedInCompany != '-1' && user?.company_id !== loggedInCompany) {
        switchCurrentCompany(loggedInCompany)
        return
      }
      if (loggedInCompany == '-1') {
        dispatch(
          setDashboardCards([
            {
              title: 'ADD COMPANY',
              path: `/add-company`,
              icon: OnboardingSVG,
            },
          ])
        )
      }
    }
  }, [loggedInCompany])

  return (
    <div className='flex flex-col w-full h-full relative overflow-auto select-none bg-secondary-2'>
      {showAddCompany ? (
        <AddCompanyModal
          isOpen={showAddCompany}
          closeModal={() => setShowAddCompany(false)}
        />
      ) : null}
      <div
        className='flex px-[15px] pt-[30px] cursor-pointer'
        onClick={() => {
          history.push('/')
        }}
      >
        <img src={LogoSVG} alt='' className='w-[140px]' />
      </div>
      <hr className='!bg-white min-h-[3px] mb-0 ' />
      {companyOptions.length > 0 ? (
        <div className='flex flex-col items-center w-full h-[40px]'>
          <FormSelect
            value={loggedInCompany}
            options={companyOptions}
            onChange={(selected) => {
              setLoggedInCompany(selected)
            }}
            type='default'
            extraClass={
              '!text-black font-bold bg-white bg-opacity-25 !h-[35px] !text-[12px] !border-none min-w-[225px]'
            }
          />
        </div>
      ) : (
        <div className='w-full flex justify-end mt-2 -mb-1'>
          <LoadingBar loading={true} />
        </div>
      )}

      <hr className='!bg-white min-h-[3px]' />
      <div className='flex flex-col justify-between h-full mb-3 gap-2 '>
        <div className='flex flex-col'>
          {switchLoading ? (
            <div className='flex flex-col min-w-full min-h-[100%] text-center justify-center'>
              <LoadingBar loading={switchLoading} sidebar={true} />
            </div>
          ) : (
            <>
              {sidebarItems?.map((item, index) => (
                <NavLink
                  key={index}
                  to={item.route}
                  className='text-color-white font-normal text-[13px] leading-[20px] flex pl-[20px] h-[42px] items-center hover:text-color-white hover:font-semibold hover:bg-white hover:bg-opacity-5'
                  activeClassName={
                    'font-bold text-[15px] text-color-white bg-white bg-opacity-10 border-l-4 border-l-white'
                  }
                >
                  <img
                    src={item.icon}
                    alt={item.name}
                    className={'pr-[15px]'}
                    width={'30px'}
                    height={'35px'}
                  />
                  {item.name}
                </NavLink>
              ))}
            </>
          )}
        </div>
        <div className='flex flex-col gap-2 w-full px-3 items-start'>
          <span className='text-white font-semibold '>
            Download mobile app on:
          </span>
          <a
            href='https://play.google.com/store/apps/details?id=com.centelhr.app'
            className='mb-1 w-full flex justify-start cursor-pointer'
            target='_blank'
          >
            <img className='w-[150px]' src={GoogleImage} alt='android' />
          </a>
          <a
            href='https://apps.apple.com/ng/app/centelhr/id6743995408'
            className='mb-1 w-full flex justify-start cursor-pointer'
            target='_blank'
          >
            <img className='w-[155px]' src={AppleImage} alt='ios' />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
